module.exports = __webpack_public_path__ + "img/box-skins-red.105d63c7.png";